import * as React from 'react';
import {connect} from 'react-redux';

export interface LoaderProps {
    isLoading: boolean;
}

const mapStateToProps = (state) => {
    const stateProps = {
        isLoading: state.app.getIsLoading()
    };
    return stateProps;
};

class Loader extends React.PureComponent<LoaderProps> {

    public render() {
        return this.props.isLoading && <div className={'load'}>
            <div className='load__icon-wrap'>
                <svg className='load__icon'>
                    <path fill='#6747cd' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z'/>
                </svg>
            </div>
        </div>
    }
}

export default connect(mapStateToProps)(Loader);


// WEBPACK FOOTER //
// ./src/components/common/loader.tsx